import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { IonicModule } from "ionic-angular";

import { MenuListComponent } from './menu-list/menu-list';
import { CampaignNamePipe } from './pipes/campaign-name.pipe';
import { MapValuesPipe } from './pipes/map-values.pipe';
import { TranslatePipe } from './pipes/translate.pipe';

@NgModule({
  declarations: [
    CampaignNamePipe,
    MapValuesPipe,
    TranslatePipe,
    MenuListComponent
  ],
  imports: [
    CommonModule,
    IonicModule
  ],
  exports: [
    CampaignNamePipe,
    MapValuesPipe,
    TranslatePipe,
    MenuListComponent
  ]
})
export class SharedModule {
}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts